const DEV_IT_API_URL = "http://localhost:8083";

function normalizeBaseUrl(url) {
	return (url || "").replace(/\/$/, "");
}

export function getItApiBaseUrl() {
	if (process.env.NODE_ENV === "development") {
		const explicitItUrl = normalizeBaseUrl(process.env.REACT_APP_IT_API_URL || "");
		return explicitItUrl || DEV_IT_API_URL;
	}

	const configuredUrl = normalizeBaseUrl(
		process.env.REACT_APP_IT_API_URL || process.env.REACT_APP_API_URL || ""
	);
	if (configuredUrl) {
		return configuredUrl;
	}

	return "";
}

export function itApiFetch(path, options = {}) {
	const normalizedPath = path.startsWith("/") ? path : `/${path}`;
	const defaultOptions = {
		credentials: "include",
	};

	return fetch(`${getItApiBaseUrl()}${normalizedPath}`, {
		...defaultOptions,
		...options,
	});
}